"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _close = _interopRequireDefault(require("@parchment/ui-icons/lib/ai/close-1"));

require("./TitlePage.less");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var TitlePage = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(TitlePage, _React$Component);

  var _super = _createSuper(TitlePage);

  function TitlePage(props) {
    var _this;

    (0, _classCallCheck2.default)(this, TitlePage);
    _this = _super.call(this, props);
    _this.onClose = _this.onClose.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(TitlePage, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          icon = _this$props.icon,
          title = _this$props.title,
          closeText = _this$props.closeText,
          showCloseButton = _this$props.showCloseButton,
          action = _this$props.action,
          className = _this$props.className,
          textStyle = _this$props.textStyle,
          children = _this$props.children;
      var actionDiv = null;

      if (action) {
        actionDiv = /*#__PURE__*/_react.default.createElement("div", {
          className: "pull-right title-page-header-action"
        }, action);
      } else if (showCloseButton) {
        actionDiv = /*#__PURE__*/_react.default.createElement("div", {
          className: "pull-right title-page-close-text",
          onClick: this.onClose
        }, closeText.toUpperCase());
      }

      return /*#__PURE__*/_react.default.createElement("div", {
        className: "title-page ".concat(className)
      }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
        className: "title-page-header clearfix"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "pull-left"
      }, icon && /*#__PURE__*/_react.default.createElement("span", {
        className: "title-page-icon"
      }, icon), /*#__PURE__*/_react.default.createElement("span", {
        className: "title-page-header-text ".concat(textStyle)
      }, title)), actionDiv), showCloseButton && /*#__PURE__*/_react.default.createElement("div", {
        className: "title-page-close"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "title-page-close-icon",
        "aria-hidden": "true",
        onClick: this.onClose
      }, /*#__PURE__*/_react.default.createElement(_close.default, null)))), /*#__PURE__*/_react.default.createElement("div", {
        className: "title-page-content"
      }, children));
    }
  }, {
    key: "onClose",
    value: function onClose() {
      if (this.props.onClose) {
        this.props.onClose();
      }
    }
  }], [{
    key: "propTypes",
    get: function get() {
      return {
        icon: _propTypes.default.any,
        title: _propTypes.default.string.isRequired,
        closeText: _propTypes.default.string,
        onClose: _propTypes.default.func,
        showCloseButton: _propTypes.default.bool,
        action: _propTypes.default.any,
        textStyle: _propTypes.default.oneOf(['', 'bold']),
        className: _propTypes.default.string
      };
    }
  }, {
    key: "defaultProps",
    get: function get() {
      return {
        closeText: 'close',
        className: '',
        showCloseButton: true,
        textStyle: ''
      };
    }
  }]);
  return TitlePage;
}(_react.default.Component);

exports.default = TitlePage;